import { createContext } from 'react';

const medicationListContext = createContext();

export default medicationListContext;
